import {
  GET_CURRENT_BOOKING_SLOTS_FAILURE,
  GET_CURRENT_BOOKING_SLOTS_REQUEST,
  GET_CURRENT_BOOKING_SLOTS_SUCCESS,
  UPDATE_BOOKING_SLOT_FAILURE,
  UPDATE_BOOKING_SLOT_REQUEST,
  UPDATE_BOOKING_SLOT_SUCCESS,
} from "./ActionType";

const initialState = {
  slots: [],
  slotUpdated: {},
  loading: false,
  error: null,
};

export const bookingSlotReducer = (state = initialState, action) => {
  switch (action.type) {
    case [GET_CURRENT_BOOKING_SLOTS_REQUEST, UPDATE_BOOKING_SLOT_REQUEST]:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_CURRENT_BOOKING_SLOTS_SUCCESS:
      return {
        ...state,
        slots: action.payload,
        loading: false,
        error: null,
      };
    case [GET_CURRENT_BOOKING_SLOTS_FAILURE, UPDATE_BOOKING_SLOT_FAILURE]:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_BOOKING_SLOT_SUCCESS:
      return {
        ...state,
        slotUpdated: action.payload,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
